export default "__VITE_ASSET__2Hyi3bOn__"